package com.gloopgo.game.viewmodel

import com.gloopgo.game.engine.ANIMAL_SKIN_OPTIONS

/**
 * UI state for the Main Menu screen.
 */
data class MenuUiState(
    val playerName: String = "",
    val selectedEmoji: String = ANIMAL_SKIN_OPTIONS.first().emoji,
    val selectedColor: Long? = null,
    val isValid: Boolean = true,
    /** True when the current nickname contains blocked profanity (length may still be OK). */
    val hasProfanity: Boolean = false,
    val bestScore: Int = 0,
    val gamesPlayed: Int = 0,
    val totalKills: Int = 0,
    val spBestScore: Int = 0,
    val spGamesPlayed: Int = 0,
    val spTotalKills: Int = 0
)
